/**
 * Typed Redux Hooks
 * Use these hooks instead of plain `useDispatch` and `useSelector`
 */

import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { RootState } from './index';
import type { AppThunkDispatch } from './store.types';

/**
 * Typed useDispatch hook with proper thunk support
 * This version properly handles AsyncThunkAction types
 */
export const useAppDispatch: () => AppThunkDispatch = useDispatch;

/**
 * Typed useSelector hook
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
